import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPolitics: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="politics, speaker, press-conference, speech"><path d="M5.75 8V5L8.75 3" stroke="currentColor" strokeWidth="1.5"/><path d="M18.25 8V5L15.25 3" stroke="currentColor" strokeWidth="1.5"/><circle cx="8.75" cy="3" r="1.75" fill="currentColor"/><circle cx="15.25" cy="3" r="1.75" fill="currentColor"/><path d="M3.75 7.75H20.25V11.25H3.75V7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5 11.5L6 20.25H18L19 11.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPolitics;
